import { PropsWithChildren } from "react";

import { Backdrop, CircularProgress } from "@mui/material";

interface Props extends PropsWithChildren {
  open: boolean;
  navigationWidth: number;
}

export function PageContentBackdropWithLoader(props: Props) {
  return (
    <Backdrop
      open={props.open}
      sx={{
        color: (theme) => theme.palette.primary.main,
        zIndex: (theme) => theme.zIndex.modal + 1,
        position: "fixed",
        top: 0,
        left: props.navigationWidth,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
      }}
    >
      <CircularProgress />
    </Backdrop>
  );
}
